import { Fragment } from 'react'
import { useQuery } from '@tanstack/react-query'
import { CaseFn } from '../api/getCase'

//import { notFound } from 'next/navigation'

import { Layout1 } from './Layouts/Layout1'
import { Layout2 } from './Layouts/Layout2'
import { Layout3 } from './Layouts/Layout3'
import { Layout4 } from './Layouts/Layout4'
import { Layout5 } from './Layouts/Layout5'
import { Layout6 } from './Layouts/Layout6'
import { Layout7 } from './Layouts/Layout7'
import { Layout8 } from './Layouts/Layout8'
import { Layout9 } from './Layouts/Layout9'

interface PageContentProps {
 slug: string | undefined
}

export interface CaseData {
 cf_id: number
 cf_client_name: string
 cf_title: string
 cf_subtitle: string
 cf_img_header: string
 cf_text_title: string
 cf_text: string
 cf_images: string
 cf_videos: string
 cf_layout: number
}

export function PageContent({ slug }: PageContentProps) {
 const { data: caseContent, isError } = useQuery<CaseData[]>({
  queryKey: ['caseFull', slug],
  queryFn: () => CaseFn({ slug }),
  staleTime: 1000 * 60 * 60 * 24, // 1 dia
  enabled: !!slug
 })

 if (isError || (caseContent && caseContent.length === 0)) {
  //notFound()
 }

 return (
  <>
   {caseContent?.map(content => {
    const folderName = content.cf_client_name
     .normalize('NFD')
     .replace(/[\u0300-\u036f]/g, '')
     .toLowerCase()
     .trim()
     .replace(/\s+/g, '-')
     // eslint-disable-next-line no-useless-escape
     .replace(/[^a-z0-9\-]/g, '')

    const images = content.cf_images?.split(',') || []
    const videos = content.cf_videos?.split(',') || []

    const files = []
    const maxLength = Math.max(images.length, videos.length)

    for (let i = 0; i < maxLength; i++) {
     if (images[i]) {
      files.push({ type: 'image', src: images[i] })
     }
     if (videos[i]) {
      files.push({ type: 'video', src: videos[i] })
     }
    }

    return (
     <Fragment key={content.cf_id}>
      <div className="container">
       <div className="w-full sm:w-full md:w-full lg:w-9/12">
        <h1 className="font-['rns-milesblack'] font-bold max-[768px]:text-2xl text-[3.4em] leading-[1.1] text-[var(--text-main)] tracking-[-0.04em] max-w-[700px]">
         {content.cf_title}
        </h1>
        <br />
        <h2 className="font-['rns-milesblack'] font-bold text-[var(--text-main)] text-sm tracking-[0.5em] uppercase leading-[1.3]">
         {content.cf_client_name === 'Rescue Monas Flower'
          ? 'Rescue | Monas Flower'
          : content.cf_client_name}
        </h2>
       </div>
       <div className="w-full sm:w-full md:w-1/2 lg:w-1/3">
        <div
         className="border-t-[1px] py-5 my-6 text-[var(--subtitle)] font-[rns-milesregular] font-normal text-[17px]"
         dangerouslySetInnerHTML={{ __html: content.cf_subtitle }}
        />
       </div>
      </div>
      <div className="w-full">
       <div
        style={{
         backgroundImage: `url(https://www.admancriativa.com.br/assets/img/cases/full/${folderName}/header/${content.cf_img_header})`
        }}
        className="w-full bg-fixed bg-cover bg-center min-[1200px]:bg-left-top bg-no-repeat relative max-[768px]:h-[350px] bg-inherit mt-[46px] h-[1070px] transition-all"
       ></div>
      </div>
      {content.cf_text_title && content.cf_text && (
       <div className="bg-[var(--backgroundGray)]">
        <div className="container">
         <div className="w-full sm:w-full md:w-full lg:w-9/12 py-14">
          <div
           className="font-['rns-milesblack'] font-bold max-[768px]:text-2xl text-[3.4em] leading-[1.1] text-[var(--text-main)] tracking-[-0.04em] max-w-[880px]"
           dangerouslySetInnerHTML={{ __html: content.cf_text_title }}
          />
          <br />
          <div
           className="text-[var(--text-main)] font-[rns-milesregular] font-normal text-[17px] cfText"
           dangerouslySetInnerHTML={{ __html: content.cf_text }}
          />
         </div>
        </div>
       </div>
      )}

      {content.cf_layout === 1 && <Layout1 data={content} files={files} />}
      {content.cf_layout === 2 && <Layout2 data={content} files={files} />}
      {content.cf_layout === 3 && <Layout3 data={content} files={files} />}
      {content.cf_layout === 4 && <Layout4 data={content} files={files} />}
      {content.cf_layout === 5 && <Layout5 data={content} files={files} />}
      {content.cf_layout === 6 && <Layout6 data={content} files={files} />}
      {content.cf_layout === 7 && <Layout7 data={content} files={files} />}
      {content.cf_layout === 8 && <Layout8 data={content} files={files} />}
      {content.cf_layout === 9 && <Layout9 data={content} files={files} />}
     </Fragment>
    )
   })}
  </>
 )
}
